import { postRequest } from "components/Common/Utils";
import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  CardTitle,
  Spinner,
  Badge,
  Button,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import { useHistory } from "react-router-dom";
import moment from "moment";
import StockAlretTable from "./StockAlretTable";

const Notifications = () => {
  const history = useHistory();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      setError(null);
      const payload = {
        page: 1,
        limit: 5,
        search: "",
        sortField: "createdAt",
        sortOrder: "desc",
        type: "order",
      };
      const response = await postRequest("notification/admin-list", payload);

      if (response.status && response.data) {
        const sortedNotifications = (response.data.notifications || []).sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setNotifications(sortedNotifications);
      } else {
        throw new Error(response.message || "Failed to load notifications");
      }
    } catch (err) {
      setError(err.message || "Failed to load notifications");
    } finally {
      setLoading(false);
    }
  };

  const handleNotificationClick = async (notification) => {
    try {
      if (!notification.readStatus) {
        await postRequest(`/notification/admin-read`, {
          notificationId: notification._id,
        });
        setNotifications(
          notifications.map((n) =>
            n._id === notification._id ? { ...n, readStatus: true } : n
          )
        );
      }

      if (notification.type === "order" && notification.typeId) {
        history.push(`/user-order-details/${notification.typeId}`);
      } else if (
        notification.type === "manufacture-order" &&
        notification.typeId
      ) {
        history.push(`/order-sent-manufacturer/${notification.typeId}`);
      }
    } catch (err) {
      console.error("Error handling notification click:", err);
    }
  };

  const handleViewDetails = (notification) => {
    if (notification.type === "order") {
      history.push(`/user-order-details/${notification.typeId}`);
    } else if (notification.type === "manufacture-order") {
      history.push(`/order-sent-manufacturer/${notification.typeId}`);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const unreadCount = notifications.filter((n) => !n.readStatus).length;

  return (
    <React.Fragment>
      <Row className="top-analtics">
        <Col xl={12}>
          <Card>
            <CardTitle className="d-flex justify-content-between align-items-center">
              <h4>
                Latest Orders{" "}
                {unreadCount > 0 && (
                  <Badge color="danger" pill className="ms-2">
                    {unreadCount} New
                  </Badge>
                )}
              </h4>
            </CardTitle>
            <CardBody
              className="mt-3"
              style={{ height: "auto", overflow: "hidden" }}
            >
              {loading ? (
                <div className="text-center py-3">
                  <Spinner color="primary" />
                  <p className="mt-2">Loading notifications...</p>
                </div>
              ) : error ? (
                <div className="text-center py-3 text-danger">
                  <p>{error}</p>
                  <Button color="primary" onClick={fetchNotifications}>
                    Retry
                  </Button>
                </div>
              ) : notifications.length > 0 ? (
                <ListGroup>
                  {notifications.map((notification) => (
                    <ListGroupItem
                      key={notification._id}
                      className={`${!notification.readStatus ? "fw-bold" : ""}`}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <div
                          style={{ flex: 1, cursor: "pointer" }}
                          onClick={() => handleNotificationClick(notification)}
                        >
                          <h6 className="mb-1">{notification.title}</h6>
                          <p className="mb-1 text-muted">
                            {notification.description}
                          </p>
                          <small>
                            {moment(notification.createdAt).format(
                              "DD-MM-YYYY hh:mm A"
                            )}
                          </small>
                        </div>
                        <div className="d-flex align-items-center">
                          {!notification.readStatus && (
                            <span className="badge bg-success me-2">New</span>
                          )}
                          <Button
                            color="primary"
                            size="mx-2"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleViewDetails(notification);
                            }}
                          >
                            View
                          </Button>
                        </div>
                      </div>
                    </ListGroupItem>
                  ))}
                </ListGroup>
              ) : (
                <div className="text-center py-3">
                  <p>No notifications found</p>
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Notifications;
